import type { ColumnDef } from "@tanstack/react-table"

import { AccountStateBadge } from "@/components/accounts/account-state-badge"
import TextLink from "@/components/text-link"
import { Badge } from "@/components/ui/badge"
import { adminAccountPath } from "@/routes"
import type { Account } from "@/types"

export const columns: ColumnDef<Account>[] = [
  {
    accessorKey: "name",
    enableSorting: true,
    header: "Name",
    cell: ({ row }) => {
      return (
        <div className="flex items-center gap-2">
          <TextLink href={adminAccountPath(row.original.uid)} as="div" prefetch>
            {row.original.name}
          </TextLink>
          {row.original.demo_mode && <Badge variant="secondary">Demo</Badge>}
        </div>
      )
    },
  },
  {
    accessorKey: "last_activity_at",
    enableSorting: true,
    header: "Last activity",
    cell: ({ row }) =>
      row.original.last_activity_at
        ? new Date(row.original.last_activity_at).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })
        : "-",
  },
  {
    accessorKey: "created_at",
    enableSorting: true,
    header: "Created",
    cell: ({ row }) =>
      new Date(row.original.created_at).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      }),
  },
  {
    accessorKey: "state",
    enableSorting: true,
    header: "Status",
    cell: ({ row }) => <AccountStateBadge state={row.original.state} />,
  },
]
